import { isSameId } from "../../helpers";
export default function (store, { id, card, replace }) {
    const state = store.getState();
    let originalCard;
    const cards = state.cards.map(c => {
        if (isSameId(c.id, id)) {
            originalCard = { ...c };
            if (replace) {
                return { id, ...card };
            }
            return { ...c, ...card };
        }
        return c;
    });
    const { cardsMap, areasMeta } = store.getInnerState({
        ...state,
        cards,
    });
    store.setState({ cards, cardsMap, areasMeta });
    return () => {
        store.in.exec("update-card", {
            id,
            card: originalCard,
            replace: true,
            $meta: { skipHistory: true },
        });
    };
}
//# sourceMappingURL=update.js.map